export default __webpack_public_path__ + "media/assets/fonts/081_font_iom-1b09bd0726caa6df65ea6301bafe3f0f.woff";